import { defineComponent as _defineComponent } from 'vue'
import { AbIcon, AbLink } from '../../../ui';
import { CdnImg } from '@webplatform/cdn-image';
import HtmlRenderer from '../../..//ui/HtmlRenderer.vue';

interface Props {
  award: {
    image?: string | null;
    alt?: string | null;
    text?: string | null;
    link?: string | null;
  };
  index: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionAwardsItem',
  props: {
    award: null,
    index: null
  },
  setup(__props: any) {



return { __sfc: true,AbIcon, AbLink, CdnImg, HtmlRenderer }
}

})